import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchFAQList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/faqs", baseUrl);

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  if (params.hospitalName) {
    endpointUrl.searchParams.append("hospitalName", params.hospitalName);
  }
  if (params.hospitalMemberId) {
    endpointUrl.searchParams.append(
      "hospitalMemberId",
      params.hospitalMemberId
    );
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useFAQList(params = {}) {
  return usePaginationQuery(
    [
      "faq",
      params.from,
      params.to,
      params.status,
      params.hospitalMemberId,
      params.hospitalName,
    ],
    (paginationState) => fetchFAQList({ ...params, ...paginationState })
  );
}
async function addFaq(formData) {
  const data = await http(`/admin/faqs`, {
    data: formData,
  });
  return data;
}

export function useAddfaq() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(addFaq, {
    onSuccess: () => {
      queryClient.refetchQueries(["faq"]);
      setTimeout(() => {
        navigate("/bulletin-board/");
      }, 1500);
    },
  });
}

export function useUpdatefaq() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/faqs/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["faq"]);
        setTimeout(() => {
          navigate("/bulletin-board/");
        }, 1500);
      },
    }
  );
}

async function deleteFaqById(id) {
  const data = await http(`/admin/faqs/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteFaqById() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteFaqById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["faq"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchFaqDownload() {
  const { data } = await http(`/admin/faq-download`, {
    responseType: "blob",
  });

  return data;
}

export function useFaqDownload() {
  const { data, ...raResult } = useQuery(["faq-download"], () =>
    fetchFaqDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
